export default __webpack_public_path__ + "static/media/2_banner-dev-software.4aa81b56.jpg";